import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import {
  Tab,
  List,
  ListItem,
  ListItemText,
  Collapse,
  Typography,
} from '@material-ui/core'
import { Tabs, Loader, Button } from 'sputnik-ui'
import {
  fetchPartnerPrograms,
  activatePartnerProgram,
  deactivatePartnerProgram,
  setPartnerProgramsFilter,
} from './partnerProgramsSlice'

const KIND_LABELS = {
  beward: 'Beward',
}

const FILTERS = [
  { label: 'Все', value: 'all' },
  { label: 'Подключены', value: 'active' },
  { label: 'Доступны', value: 'inactive' },
]

function PartnerProgramItem({ program, companyUuid }) {
  const dispatch = useDispatch()
  const [expanded, setExpanded] = useState(false)
  const togglingId = useSelector(
    ({ partnerPrograms }) => partnerPrograms.togglingId,
  )
  const isToggling = togglingId === program.id

  const handleToggle = (e) => {
    e.stopPropagation()
    if (program.state === 'active') {
      dispatch(deactivatePartnerProgram({ companyUuid, programId: program.id }))
    } else {
      dispatch(activatePartnerProgram({ companyUuid, programId: program.id }))
    }
  }

  return (
    <>
      <ListItem button onClick={() => setExpanded(!expanded)}>
        <ListItemText
          primary={KIND_LABELS[program.kind] || program.kind}
          secondary={program.state === 'active' ? 'Подключена' : 'Доступна'}
        />
      </ListItem>
      <Collapse in={expanded} unmountOnExit>
        <div style={{ padding: '0 16px 1rem' }}>
          <Typography color="textSecondary">
            Стоимость: {program.payout_price} ₽
          </Typography>
          <Button
            rounded
            color={program.state === 'active' ? 'danger' : 'success'}
            disabled={isToggling}
            style={{ marginTop: '0.5rem' }}
            onClick={handleToggle}>
            {program.state === 'active' ? 'Отключить' : 'Включить'}
          </Button>
        </div>
      </Collapse>
    </>
  )
}

export default function PartnerProgramsList() {
  const dispatch = useDispatch()
  const selectedCompanyUuid = useSelector(
    ({ companies }) => companies.selected?.value,
  )
  const programs = useSelector(({ partnerPrograms }) => partnerPrograms.list)
  const pending = useSelector(({ partnerPrograms }) => partnerPrograms.pending)
  const filter = useSelector(({ partnerPrograms }) => partnerPrograms.filter)

  useEffect(() => {
    if (selectedCompanyUuid) {
      dispatch(
        fetchPartnerPrograms({
          companyUuid: selectedCompanyUuid,
          state: filter === 'all' ? undefined : filter,
        }),
      )
    }
  }, [dispatch, selectedCompanyUuid, filter])

  return (
    <>
      <Tabs
        onChange={(e, value) => dispatch(setPartnerProgramsFilter(value))}
        value={filter}>
        {FILTERS.map((f) => (
          <Tab disableRipple label={f.label} value={f.value} key={f.value} />
        ))}
      </Tabs>
      {pending && <Loader />}
      {!pending && programs && programs.length === 0 && (
        <Typography color="textSecondary" style={{ padding: '1rem' }}>
          Нет партнерских программ
        </Typography>
      )}
      {!pending && programs && programs.length > 0 && (
        <List style={{ width: '100%' }}>
          {programs.map((program) => (
            <PartnerProgramItem
              program={program}
              companyUuid={selectedCompanyUuid}
              key={program.id}
            />
          ))}
        </List>
      )}
    </>
  )
}
